import React from "react";
import Typography from "../../../Utility/Typography";
import Input from "../../../Utility/Input/Input";
import Button from "../../../Utility/Button/Button";

const projects = [
  { name: "CEDAR", key: "CDRA" },
  { name: "HCTB", key: "HCTB" },
  { name: "Report Development", key: "RD" },
];

const Popup = ({ onSelect, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black/30 flex justify-center items-center z-[9999]">
      <div className="bg-white w-96 rounded-lg p-4">
        <Typography variant="h4" className="font-semibold mb-3">
          Add where your team works
        </Typography>
        <Input label="Search or paste link" placeholder="Search or paste link" noWrapper={true} />
        <Typography variant="span2" className="font-semibold mb-2" component="p">
          Recent projects
        </Typography>

        {projects.map((p) => (
          <div
            key={p.key}
            onClick={() => onSelect(p)}
            className="p-2 hover:bg-gray-100 cursor-pointer rounded"
          >
            <Typography variant="span2" className="font-medium" component="p">
              {p.name}
            </Typography>
            <Typography variant="span2" className="text-xs text-gray-500" component="p">
              {p.key}
            </Typography>
          </div>
        ))}
        <Button onClick={onClose} variant="primary" size="sm">
          Close
        </Button>
      </div>
    </div>
  );
};

export default Popup;
